import React, {useEffect, useState} from 'react'
import DLLoader from "../../core/components/DLLoader/DLLoader";
import DLText from "dlcomponent/components/DLText/DLText";
import DLButton from "dlcomponent/components/DLButton/DLButton";
import * as XLSX from "xlsx";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import IndustryChart from "./IndustryChart";
import IndustryTable from "./IndustryTable";
import {getFundSummary, getIndustrySummary, getStocksSummary} from "../HomepageAction";
import CustomTabPanel from "../../component-utils/CustomTabPanel/CustomTabPanel";
import {downloadExcel} from "../../utils/downloadExcel";
import ChartRadioGroup from "../../component-utils/ChartRadioGroup/ChartRadioGroup";
import {withRouter} from "react-router-dom";
import {getTrimVal} from "../../utils/helper";
import {isEmpty} from "../../utils/validations";


function Industry(props) {

    useEffect(() => {

        getIndustrySummary(props.currentMonthDate).then((res) => {
            setIsLoading(false);
            if (res.success && !isEmpty(res.data?.data)) {
                setTableData(res.data.data)
                setIndustryGraph(res.data.data);
            }
        })

    }, []);

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }


    const [chartLabelsArray, setChartLabelsArray] = useState([]);
    const [chartDataArray, setChartDataArray] = useState([]);
    const [tableData, setTableData] = useState([])
    const [tabValue, setTabValue] = React.useState(0);




    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const deepCopy = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    }

    //order by descending
    const compareByMarketValueChangeMoM = (a, b) => {
        if (a.market_value_change_mom < b.market_value_change_mom) {
            return 1;
        }
        if (a.market_value_change_mom > b.market_value_change_mom) {
            return -1;
        }
        return 0;
    }

    const compareByMarketValueChangePercent = (a, b) => {
        if (a.percentage_market_value_change < b.percentage_market_value_change) {
            return 1;
        }
        if (a.percentage_market_value_change > b.percentage_market_value_change) {
            return -1;
        }
        return 0;
    }


    const handleRadioChange = (event) => {
        let chartType = event.target.value
        let newChartData = [];
        let newLabelData = [];
        if(chartType === 'marketValue'){
            for (let i = 0; i < 20; i++) {
                let labelData = tableData[i].industry;
                let chartData = tableData[i].total_market_value;
                newChartData.push(chartData);
                newLabelData.push(labelData);
            }
        }else if(chartType === 'changeMoM'){
            let changeMoMData = deepCopy(tableData);
            changeMoMData.sort(compareByMarketValueChangeMoM);
            for (let i = 0; i < 20; i++) {
                let labelData = changeMoMData[i].industry;
                let chartData = changeMoMData[i].market_value_change_mom;
                newChartData.push(chartData);
                newLabelData.push(labelData);
            }
        }else if(chartType === 'changePercent'){
            for (let i = 0; i < 20; i++) {
                let changeMoMPercentage = deepCopy(tableData);
                changeMoMPercentage.sort(compareByMarketValueChangePercent);
                let labelData = changeMoMPercentage[i].industry;
                let chartData = changeMoMPercentage[i].percentage_market_value_change;
                newChartData.push(chartData);
                newLabelData.push(labelData);
            }
        }
        setChartLabelsArray(newLabelData);
        setChartDataArray(newChartData);
    };


    const handleClick = (evt, elements) => {
        if (elements.length > 0) {
            let clickedIndustry = tableData[elements[0].index]
            props.history.push('/sectors/'+clickedIndustry.industry)
        }
    };



    const setIndustryGraph = (data) => {
        const {isLGView, isXLView} = props;

        for (let i = 0; i < 20; i++) {

            let industryName = getTrimVal(data[i].industry, isLGView, isXLView);
            let marketValue = (data[i].total_market_value)?.toFixed(2);

            setChartLabelsArray(industryNames => [...industryNames, industryName]);
            setChartDataArray(marketValueInCrores => [...marketValueInCrores, marketValue]);

        }
    };


    const [isLoading, setIsLoading] = useState(true);


    if (isLoading) {
        return (
            <div className={'row px-2 h-100'}>
                <div className={"col-12 d-flex flex-column justify-content-center align-items-center mb-1"}>
                    <DLLoader type={'inline'} isVisible={true}/>
                </div>
            </div>
        )
    }
    return (
        <div>
            <div className='d-flex justify-content-between px-3 py-2'>
                <div>
                    <DLText
                        id={'summary-by-country'}
                        type={'normal'}
                        text={'Sectors'}
                        fontWeight={'semi-bold'}
                        fontSize={'md'}/>
                </div>
                {/*<DLButton*/}
                {/*    id={'download-excel'}*/}
                {/*    styleType={"outlined"}*/}
                {/*    borderType={'rounded'} buttonSize={'sm'}*/}
                {/*    sideMargin={"none"}*/}
                {/*    reduceWidth={true}*/}
                {/*    type={'primary'}*/}
                {/*    onClick={()=>downloadExcel(tableData)}*/}
                {/*    label={<i className='fas fa-download fs-6'/>}*/}
                {/*/>*/}
                <div className='ms-3 d-flex align-items-center justify-content-center downloadButtonCss cursor'>
                    <i className='fas fa-download fs-6'
                       onClick={()=>downloadExcel(tableData)}
                       style={{fontSize: 12}}/>
                </div>
            </div>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Chart" {...a11yProps(0)} sx={{ textTransform:'capitalize'}}/>
                        <Tab label="Table" {...a11yProps(1)} sx={{ textTransform:'capitalize'}}/>
                    </Tabs>
                </Box>
                <CustomTabPanel value={tabValue} index={0}>
                    <ChartRadioGroup handleRadioChange={handleRadioChange}/>
                    <IndustryChart yAxis={chartLabelsArray} xAxis={chartDataArray} handleClick={handleClick} />
                </CustomTabPanel>
                <CustomTabPanel value={tabValue} index={1}>
                    <IndustryTable data={tableData}/>
                </CustomTabPanel>
            </Box>

        </div>
    )

}

export default withRouter(Industry);
